import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Card from "../Card/Card.js";
import CardHeader from "../Card/CardHeader.js";
import GridItem from "../Grid/GridItem.js";
import Button from "../CustomButtons/Button.js";

import format from "../../services/Format";
import api from "../../services/api";

import moment from 'moment-timezone';
import 'moment/locale/pt-br';
moment.locale('pt-br');

export default function ModalInconsistencias() {
  const history = useHistory();
  const [tableData, setTableData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    setData();
  }, []);

  const setData = async () => {
    setModalVisible(false);
    setTableData([]);
    let currentMonth = parseInt(moment().format("MM"));
    let currentYear = parseInt(moment().format("YYYY"));
    let dados = await api.buscarBatidas(currentMonth, currentYear);
    if (dados.success) {
      if (dados.data.length > 0) {
        let items = [];
        let aItens = [];

        for (let doc of dados.data) {
          items.push(doc);
        }

        items.sort((a, b) => {
          return a.hora?.replace(':', '') - b.hora?.replace(':', '')
        });

        let daysInMonth = moment(new Date()).daysInMonth();
        for (let d = 1; d <= daysInMonth; d++) {
          let aHoras = [];
          let arr = items?.filter(a => {
            return a.dia === d
          });

          for (let batida of arr) {
            aHoras.push(batida.hora);
          }

          if (arr?.length > 0) {
            let day = moment(arr[0].dataPorExtenso?.split("/").reverse().join("-"));
            let today = moment(new Date()).format('YYYY-MM-DD');
            if (day.isBefore(today)) {
              let arrBatidas = arr.filter(o => !o.anexo && o.hora || o.anexo && o.hora);
              if (arrBatidas?.length % 2 !== 0) {
                aItens.push({
                  data: arr[0].dataPorExtenso.split("-").reverse().join("/"),
                  dia: format.capitalize(moment(arr[0].dataPorExtenso.split("/").reverse().join("-")).format('ddd')),
                  marcacoes: aHoras.join(' - ')
                });
              }
            }
          }
        }

        aItens.sort((a, b) => {
          return parseInt(b.data.split('/').join("")) - parseInt(a.data.split('/').join(""))
        });

        if (aItens.length > 0) {
          setTableData(aItens);
          setModalVisible(true);
        } else {
          setTableData([]);
          setModalVisible(false);
        }
      }
    } else {
      setTableData([]);
      setModalVisible(false);
    }
  }

  const fecharModal = () => {
    setModalVisible(false);
  }

  if (modalVisible) {
    return (
      <Card style={{
        backgroundColor: '#f8f9fd',
        borderRadius: 10,
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        borderColor: '#C8C8C8',
        minHeight: '200px',
        width: '370px',
        boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)',
        position: 'absolute',
        bottom: 0,
        right: 20
      }}>
        <CardHeader style={{ padding: '0px' }}>
          <GridItem style={{ padding: '0px', marginTop: 10, borderBottom: '1px solid #ddd', textAlign: 'center' }}>
            <i className="icon-road-sign-warning" style={{ fontSize: '22px', color: '#FF9100' }} />
            <h4 style={{
              height: 'auto',
              color: '#828282',
              fontFamily: "Open Sans",
              fontSize: '14px',
              fontWeight: '600',
              lineHeight: '10px',
              marginTop: '4px',
              textAlign: 'center',
              marginBottom: '15px'
            }}>Justificativas Pendentes</h4>
          </GridItem>
        </CardHeader>

        <CardHeader style={{ paddingBottom: '5px' }}>
          <table className='table-inconsitencias'>
            <thead>
              <tr>
                <th>Data</th>
                <th>Dia</th>
                <th>Marcações Efetuadas</th>
                <th>Justificar</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, i) => {
                return (
                  <tr key={i}>
                    <td style={{ width: '85px', color: '#828282' }}>{row.data}</td>
                    <td style={{ width: '45px', color: '#828282' }}>{row.dia}</td>
                    <td style={{ width: '150px', color: '#828282' }}>{row.marcacoes}</td>
                    <td>
                      <i
                        className="icon-road-sign-warning"
                        style={{ fontSize: '20px', color: '#FF9100', cursor: 'pointer' }}
                        onClick={async () => {
                          history.push('/justificativa', { data: row.data, marcacoes: row.marcacoes });
                        }}
                      />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </CardHeader>

        <CardHeader style={{ textAlign: 'center', display: 'inline', paddingTop: '10px' }}>
          <Button style={{ borderRadius: '25px', width: 120, height: 30 }} onClick={() => fecharModal()} color="primary">Fechar</Button>
        </CardHeader>
      </Card>
    )
  } else {
    return null;
  }
}
